import type { SanityPlanCompareView } from "./useComparePlanTableSectionState";

type PlanCompareCell =
  SanityPlanCompareView["categories"][number]["rows"][number]["cells"][number];

export function planCellToIconValue(
  cell: PlanCompareCell | undefined,
): ComparePlanCellValue {
  const display = cell?.display ?? "included";
  if (display === "text") {
    return cell?.text?.trim() || "—";
  }
  return display === "included";
}

/** Cell value for plan compare UI: check, X, or custom text */
export type ComparePlanCellValue = boolean | string;
